import { z } from 'zod';

export const editSuperAdminSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  phone: z.string().optional(),
});

export type EditSuperAdminFormData = z.infer<typeof editSuperAdminSchema>;
